export default __webpack_public_path__ + "static/media/IMG_8870.cfe8e49b.jpeg";